import type { PartialCancellationFeeData, PartialCancellationParticipantFee } from '../../domain/types'
import type {
  CancellationCostsAPIResponse,
  CancellationCostsParticipantAPIResponse,
} from '../types'

function mapParticipantCost(
  participant: CancellationCostsParticipantAPIResponse,
): PartialCancellationParticipantFee | null {
  const participantId = participant.id
  const amount = participant.cancellationCost

  if (participantId === undefined || amount == null)
    return null

  return {
    participantId: String(participantId),
    cancellationCost: amount,
  }
}

function mapParticipants(
  participants?: CancellationCostsParticipantAPIResponse[],
): PartialCancellationParticipantFee[] {
  return (participants ?? [])
    .map(mapParticipantCost)
    .filter((entry): entry is PartialCancellationParticipantFee => entry !== null)
}

export function partialCancellationFeeMapper(data: CancellationCostsAPIResponse): PartialCancellationFeeData {
  const isFreeCancellationAllowed = data.isFreeCancellationAllowed === true
  const isCancellationWithCostsAllowed = data.isCancellationWithCostsAllowed === true
  const participants = isCancellationWithCostsAllowed
    ? mapParticipants(data.participantsCosts)
    : []

  return {
    participants,
    isFreeCancellationAllowed,
    isCancellationWithCostsAllowed,
  }
}
